/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types'; /* eslint-disable-line no-unused-vars */

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';

import styled from 'styled-components';

import { asField } from 'informed';
import { get, isEmpty } from 'lodash-es';

import { checkIsNull } from '../Utils/utils';
import HtmlTooltip from './HtmlTooltip';

const StyledFormControl = styled(FormControl)`
  width: 100%;
  vertical-align: baseline;
  .field {
    vertical-align: baseline;
  }
`;

const StyledTextField = styled(TextField)`
  vertical-align: baseline;
`;

class TextFieldComponent extends Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();

    this.state = {
      error: false,
      helperText: '',
      value: get(props, 'defaultValue'),
    };
  }

  componentDidMount() {
    const { fieldState, onRef } = this.props;
    if (onRef) onRef(this);
    this.setState({ value: get(fieldState, 'value') });
  }

  componentWillUnmount() {
    const { onRef } = this.props;
    if (onRef) onRef(undefined);
  }

  setValue = value => {
    this.setState({ value });
  };

  parseNumber = (type, value) => {
    if (value === '') return undefined;
    try {
      return type === 'number' && !checkIsNull(value) ? Number(value) : value;
    } catch (error) {
      return undefined;
    }
  };

  validate = (value, newArg) => {
    const { required, strings, validation } = this.props;
    let helperText = '';

    if (required && isEmpty(value)) {
      helperText = get(strings, 'validation.field.required', 'Ce champ est obligatoire');
      this.setState({ helperText, error: true });
      return;
    }

    const result = validation(value, newArg);

    if (!get(result, 'status', true)) {
      helperText = get(result, 'message', 'Champ invalide');
      this.setState({ helperText, error: true });
      return;
    }

    this.setState({ helperText, error: false });
  };

  handleChange = (event, type) => {
    const { onChange } = this.props;
    const value = get(event, 'target.value');

    this.validate(value);

    this.setValue(this.parseNumber(type, value));
    if (onChange) {
      onChange(this.parseNumber(type, value));
    }
  };

  handleBlur = (event, type) => {
    const { fieldApi, onBlur } = this.props;
    const value = get(event, 'target.value');

    this.validate(value);

    if (fieldApi.setValue) fieldApi.setValue(this.parseNumber(type, value));
    if (onBlur) {
      onBlur(this.parseNumber(type, value));
    }
  };

  render() {
    const { fieldApi, fieldState, ...props } = this.props;
    const value = get(this.state, 'value');
    const { setTouched } = fieldApi;
    const {
      field,
      defaultValue,
      shrink,
      label = '',
      id = String(Math.floor(Math.random() * 1e8)),
      helperText = '',
      required,
      type,
      // ...rest
      disabled,
      inputProps,
      tooltip,
    } = props;

    return (
      <>
        {tooltip && (
          <HtmlTooltip title={tooltip}>
            <span className="helper">?</span>
          </HtmlTooltip>
        )}
        <StyledFormControl error={!!fieldState.error}>
          <StyledTextField
            // {...rest}
            type={type}
            name={field}
            label={label}
            defaultValue={this.parseNumber(type, defaultValue)}
            ref={this.selectRef}
            value={typeof value !== 'undefined' ? value.toString() : ''}
            InputLabelProps={{ shrink }}
            onChange={event => this.handleChange(event, type)}
            onBlur={event => {
              setTouched();
              this.handleBlur(event, type);
            }}
            // material-ui props
            inputProps={{
              ...inputProps,
              //   name,
              id,
            }}
            disabled={disabled}
            required={required}
            error={get(this.state, 'error')}
            helperText={get(this.state, 'helperText')}
          />
          <FormHelperText>{fieldState.error || helperText}</FormHelperText>
        </StyledFormControl>
      </>
    );
  }
}

TextFieldComponent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fieldApi: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  fieldState: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  inputProps: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  type: PropTypes.string,
  required: PropTypes.bool,
  strings: PropTypes.object, // eslint-disable-line
  validation: PropTypes.func,
  tooltip: PropTypes.string, // eslint-disable-line
};

TextFieldComponent.defaultProps = {
  disabled: false,
  required: false,
  type: 'text',
  strings: {},
  inputProps: {},
  validation: () => true,
};

export default asField(TextFieldComponent);
